import 'lazyloadxt/dist/jquery.lazyloadxt.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import request from 'superagent';
import merge from 'lodash/merge';
import cookie from 'js-cookie';
import {getAppBus} from '../bootstrap';
import {actionIs, toGetParams} from '../../utils';
import {bindInterfaces} from './interfaces';
import {AD_CATALOG_BOTTOM} from './ads';
import { generateNewPageEvent, initGoToDetailEvent } from './analytics'

// Import Rx components selectively instead of `import Rx from 'rxjs/Rx';`
// to dramatically decrease bundle size
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { ADULT_USER_COOKIE } from '@constants';
import { hydrateSSRBlocks } from '@utils/ssr';
import { getClientLocale, I18NProvider } from '@utils/i18n';
import apolloWrapper from '@hoc/apolloWrapper';

import {
  priceChangeAction,
  cityFilterAction,
  sizeChangeAction,
  colorChangeAction,
  conditionChangeAction,
  brandChangeAction,
  brandInputChange,
  brandInputChanged,
  brandsSuggestionsReceived,
  clearAllFiltersAction,
  sortingDirectionChangeAction,
  priceRangeChangeAction,
  setPageAction,
  clearFilterValueAction,
  excludeFilterValueAction,
  cityChangeAction,
  cityFormSubmitAction,
  closeClickedAction,
  characteristicChanged, madeInUkraineChangeAction,
  freeShippingChangeAction,
  isOnSaleChangeAction,
} from './actions';

import { renderProductRating } from '../global/ProductRating';
import { reindexFavourite } from './toggle_favourite';
import { renderSearchSubscriberBlock } from './SearchSubscribeTelegram';
import { CatalogAppsPromotionBanner } from './components/CatalogAppsPromotionBanner';
import { AgeConfirmationModal } from '@components/AgeConfirmationModal';

let appBus = getAppBus();
let SCROLL_OFFSET = 0;
const MOUNT = '.js-filters-container';
const PJAX_MOUNT = '.js-pjax-mount';
const LOADING_CSS_CLASS = 'b-main__inner_state_loading';
const MOUNT_TAG = '.js-list-urls';

const CatalogAppsPromotionBannerComponent = apolloWrapper(
    CatalogAppsPromotionBanner,
);

export function makeUrlFilters(window, document) {
  return function () {
    const filtersContainer = document.querySelectorAll(MOUNT_TAG);
    for (const tag of filtersContainer) {
        tag.addEventListener('click', modifyLink, false)
    }
  }
}

function modifyLink(e) {
    e.preventDefault();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('page');
    searchParams.delete('search_text');
    let path;
    if (searchParams.toString() === '') {
        path = e.target.href;
      } else {
        path = `${e.target.href}?${searchParams}`
    }
    window.location.assign(path);
  }


// lazyload images
$.extend($.lazyLoadXT, {
    selector: "img.js-lazy-img",
    autoInit: false,
    oninit: function() {},
});


function requestFilteredProducts({config, state}) {
    let mainContent = document.querySelector(PJAX_MOUNT);
    mainContent.classList.add(LOADING_CSS_CLASS);
    let params = merge(state.FilterState, {
        page: state.pageNum,
        search_text: state.FilterState.search_text ? unescape(state.FilterState.search_text.replace('&amp;','&')) : null
    });
    return request
        .get(config.pjaxBaseUrl + toGetParams(params))
        .set('X-Pjax', 'true');
}

function closeModalFilter() {
    const filterblock = document.querySelector('.b-filter__container');
    filterblock.classList.remove('hidden');
}

$('.js-toggle').click(closeModalFilter);

function renderProducts(response, state) {
    let mainContent = document.querySelector(PJAX_MOUNT);
    mainContent.classList.remove(LOADING_CSS_CLASS);
    mainContent.innerHTML = response.text;

    // refresh ad slots
    $('.js-gslot-catalog-bottom').html(AD_CATALOG_BOTTOM);

    if (googletag && googletag.pubads) {
        googletag.pubads().refresh();
    }

    // reactivate lazy images
    $('.js-lazy-img').lazyLoadXT();

    // scroll to first products
    $('html, body').animate({
        scrollTop: $(mainContent).offset().top - SCROLL_OFFSET
    }, 300);

    // reactivate toggles
    $(".js-toggle[data-target-id!=''][data-target-id][data-toggle-classname!=''][data-toggle-classname]", PJAX_MOUNT).click(function(){
        var $this = $(this);
        $("#"+$this.data("targetId")).toggleClass($this.data("toggleClassname"));
    });
    // reactivate favourites
    reindexFavourite();

    // reactivate subscriber block
    renderSearchSubscriberBlock();

    // rehydrate ssr blocks
    hydrateSSRBlocks();

    // add events
    initGoToDetailEvent();

    renderProductRating();
}

export function makeMain(window, document, filterComponent, modelClass, scrollOffset=0) {
    return function() {
        const blackHoleEventStream = new Subject(); // Event stream for events from DOM
        const eventStream = new Subject();
        let startup = true;
        SCROLL_OFFSET = scrollOffset;

        // Bind events on DOM elements
        // that will go directly into blackhole event stream
        bindInterfaces(document, blackHoleEventStream);

        renderProductRating();

        let initialState = new modelClass(window, document).getState();
        const filtersContainer = document.querySelector(MOUNT);
        const filtersRoot = filtersContainer ? createRoot(filtersContainer) : null;
        const appsPromotionBannerContainer = document.querySelector('.js-catalog-apps-promotion-banner');
        let filtersChangedStream = appBus.filter(actionIs('filter'));
        filtersChangedStream
            .flatMap(requestFilteredProducts)
            .do(renderProducts)
            .subscribe(
                () => {},
                console.error.bind(console)
            );


        function updateFilters([state, effect]) {
          let component = React.createElement(filterComponent, {
                eventStream: eventStream,
                priceFilters: state.FilterData.price,
                cityFilters: state.FilterData.city,
                sizeFilters: state.sizeGroupId ? state.FilterData.size_groups[state.sizeGroupId].sizes : null,
                colorFilters: state.FilterData.color,
                conditionFilters: state.FilterData.condition,
                brandFilters: state.FilterData.brand,
                data: state
            });

            filtersRoot.render(component);
        }

        function fetchWithFilters([state, effect]) {
            if (!startup) {
                appBus.next({
                    action: 'filter',
                    config: initialState.config,
                    state: state
                });
            } else {
                startup = false;
            }
        }

        // Stream that just change state of app
        const stateChangeStream = [
            eventStream.filter(actionIs('brandInputChange'))
                .map(brandInputChange),
            eventStream.filter(actionIs('brandInputChanged'))
                .debounceTime(1000)
                .distinctUntilChanged()
                .map(brandInputChanged),
            eventStream.filter(actionIs('brandsSuggestReceived')).map(brandsSuggestionsReceived),
            eventStream.filter(actionIs('cityChangeClicked')).map(cityChangeAction),
            eventStream.filter(actionIs('cityFormSubmit')).map(cityFormSubmitAction),
            eventStream.filter(actionIs('closeClicked')).map(closeClickedAction)
        ];

        // Stream that require catalog update via network
        const updateFilterStream = [
            eventStream
                .filter(actionIs('setPriceFilter'))
                .map(priceChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setCustomPriceFilter'))
                .debounceTime(1000)
                .distinctUntilChanged()
                .map(priceRangeChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setCityFilter'))
                .map(cityFilterAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setSizeFilter'))
                .map(sizeChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setColorFilter'))
                .map(colorChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setMadeInUkraineFilter'))
                .map(madeInUkraineChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setFreeShipping'))
                .map(freeShippingChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setIsOnSale'))
                .map(isOnSaleChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('setConditionFilter'))
                .map(conditionChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('brandChanged'))
                .map(brandChangeAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('clearAllFilters'))
                .map(clearAllFiltersAction)
                .map(generateNewPageEvent),
            eventStream
                .filter(actionIs('characteristicChanged'))
                .map(characteristicChanged)
                .map(generateNewPageEvent),
            // Make event from browser's back button
            Observable
                .fromEvent(window, 'popstate')
                .map(
                    ({ state: eventState }) => (state) => {
                        const currentHref = location.href;
                        const prevHref = (state || {}).currentHref || currentHref;
                        state.currentHref = currentHref;

                        // Change page num in state, if not eventState, then we on 1st page
                        if (eventState) {
                            eventState.currentHref = currentHref;
                        } else {
                            state.pageNum = 1;
                        }
                        if (currentHref === prevHref) {
                            // Return null if href haven't been changed
                            return [eventState || state || {}, null];
                        }
                        return [eventState || state || {}];
                    }
                ),

            // Make event from catalog sorting
            blackHoleEventStream
                .filter(actionIs('sortDirectionChanged'))
                .map(sortingDirectionChangeAction)
                .map(generateNewPageEvent),

            // Handle event from pagination buttons
            blackHoleEventStream
                .filter(actionIs('setPage'))
                .map(setPageAction),

            // Handle event from clear selected filter value
            blackHoleEventStream
                .filter(actionIs('excludeFilterValue'))
                .map(excludeFilterValueAction)
                .map(generateNewPageEvent),
            blackHoleEventStream
                .filter(actionIs('clearFilterValue'))
                .map(clearFilterValueAction)
                .map(generateNewPageEvent),
            blackHoleEventStream
                .filter(actionIs('clearAllFilters'))
                .map(clearAllFiltersAction)
                .map(generateNewPageEvent),
        ];

        if (filtersRoot) {
            // Handle events that require filter update via network
            Observable
                .merge(...updateFilterStream)
                .scan(([state, effect], action) => action(state), [initialState])
                // Filter popstate event when href haven't been changed
                .filter(([_, effect]) => (effect !== null))
                .startWith([initialState])
                .do(updateFilters)
                .do(fetchWithFilters)
                .flatMap(([state, effect]) => effect ? effect(initialState.config, eventStream, state) : Observable.empty())
                .subscribe(
                    () => {},
                    console.error.bind(console)
                );

            // Handle events that just change app state
            Observable
                .merge(...stateChangeStream)
                .scan(([state, effect], action) => action(state), [initialState])
                .startWith([initialState])
                .do(updateFilters)
                .flatMap(([state, effect]) => effect ? effect(initialState.config, eventStream, state) : Observable.empty())
                .subscribe(
                    () => {},
                    console.error.bind(console)
                );
        }

        if (appsPromotionBannerContainer) {
            const root = createRoot(appsPromotionBannerContainer);

            root.render(<CatalogAppsPromotionBannerComponent />)
        }

        const ageConfirmationModalContainer = document.querySelector('.js-product-details-age-confirmation-modal');

        if (ageConfirmationModalContainer) {
            const root = createRoot(ageConfirmationModalContainer);
            const { lang, routerBasename } = getClientLocale();

            root.render(
                <BrowserRouter basename={routerBasename}>
                    <I18NProvider lang={lang}>
                        {() => (
                            <AgeConfirmationModal
                                isOpen={!cookie.get(ADULT_USER_COOKIE)}
                                onCancel={() => {
                                    window.location.href = "/"
                                }}
                                onConfirm={() => {
                                    cookie.set(ADULT_USER_COOKIE, 'true');
                                    window.location.reload();
                                }}
                            />
                        )}
                    </I18NProvider>
                </BrowserRouter>,
            );
        }

        // add events
        initGoToDetailEvent();
    }
}
